import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * Skeleton'lar jenerik gri kutu DEĞİLDİR; gerçek düzenin iskeletidir
 * (PRODUCT-DECISIONS §2). Bu yüzden aşağıda ürün kartı ve satır gibi
 * gerçek şekiller ayrıca tanımlanır — layout shift oluşmaz.
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden
      className={cn(
        'animate-pulse rounded-sm bg-surface-sunken',
        'motion-reduce:animate-none',
        className,
      )}
      {...props}
    />
  );
}

/** Ürün kartı iskeleti: 4:5 görsel + ad + fiyat + teslimat satırı */
export function ProductCardSkeleton() {
  return (
    <div className="w-full">
      <Skeleton className="aspect-4/5 w-full rounded-lg" />
      <Skeleton className="mt-3 h-4 w-4/5" />
      <Skeleton className="mt-2 h-4 w-1/3" />
      <Skeleton className="mt-2.5 h-3 w-24" />
    </div>
  );
}

export function ProductGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-8 md:grid-cols-3 lg:grid-cols-4">
      {Array.from({ length: count }, (_, index) => (
        <ProductCardSkeleton key={index} />
      ))}
    </div>
  );
}

/** Yönetim paneli liste satırı iskeleti */
export function ListRowSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="divide-y divide-line">
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className="flex items-center gap-4 py-4">
          <Skeleton className="size-11 shrink-0 rounded-sm" />
          <div className="min-w-0 flex-1">
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="mt-2 h-3 w-1/3" />
          </div>
          <Skeleton className="h-8 w-20 shrink-0" />
        </div>
      ))}
    </div>
  );
}
